import React from 'react';
import Wrapper from 'components/Wrapper';
import Text from 'components/Text';
import { fontSizes } from 'appconstants';
import { ReactSVG } from 'react-svg';
import { back_icon } from 'asset/icons';
import SectionCard from 'components/SectionCard';
import RowView from 'components/RowView';
import FinalCompletionReportFunction from './index.function';
const FinalCompletionReport = () => {
  const { navigate } = FinalCompletionReportFunction();

  return (
    <Wrapper>
      {/* Header */}
      <div className='flex items-center gap-3 mb-6'>
        <div
          onClick={() => navigate(-1)}
          className='h-10 w-10 cursor-pointer rounded-md flex items-center justify-center bg-muted hover:bg-muted/50 transition'
        >
          <ReactSVG src={back_icon} />
        </div>
        <Text text='Final Completion Report' size={fontSizes.h24} className='font-bold' />
      </div>

      {/* Top Section */}
      <div className='grid grid-cols-1 lg:grid-cols-2 gap-6'>
        {/* Wrap Up Meeting */}
        <SectionCard title='Wrap Up Meeting'>
          <Text text='The following people attended the wrap up meeting:' className='text-muted-foreground mb-2' size={fontSizes.h14} />
          <Text text='From HEB:' className='font-medium text-muted-foreground mb-1.5' size={fontSizes.h14} />
          <ul className='list-disc pl-5 text-muted-foreground'>
            <li>
              <Text text={'Effain Villaturo- QA Manager'} className='text-muted-foreground' size={fontSizes.h14} />
            </li>
            <li>
              <Text text={'Lupe Melchve- Ripener'} className='text-muted-foreground' size={fontSizes.h14} />
            </li>
            <li>
              <Text text={'Pete Castaneda - Sr. Ripener'} className='text-muted-foreground' size={fontSizes.h14} />
            </li>
            <li>
              <Text text={'Carlos Motta - Furman Facility'} className='text-muted-foreground' size={fontSizes.h14} />
            </li>
          </ul>
          <Text text='The following information was presented at the meeting:' className='text-muted-foreground mt-2' size={fontSizes.h14} />
        </SectionCard>

        <SectionCard title='Final Remarks' className=''>
          <Text
            text='The HEB team was receptive to our recommendations. We noted that most issues from last year remain unresolved, with only the problems
corrected linked to the installation of new RollSeal doors. The focus is on door leaks, which are important for maintaining proper ethylene
levels inside the rooms and protecting nearby ethylene-sensitive products. We observed that in the newest doors, about 5 years old,
caulking is missing in areas such as the door frame and around the sheet metal. Effain, who has been with the company for only two
months, asked many questions about the items discussed. After the meeting, we showed Effain one of the rooms with most of the issues
so he could better understand each problem. The team also plans to purchase a humidity reader to perform random humidity checks,
prevent fruit dehydration and potential revenue loss as we discussed.'
            className='text-muted-foreground mt-4 mb-2'
            size={fontSizes.h14}
          />
        </SectionCard>
      </div>

      <div className='grid grid-cols-1 lg:grid-cols-2 gap-6 mt-6'>
        <SectionCard title='Structural Observations'>
          <Text
            text={'Room Leaks (Ethylene, Humidity, Room Cooling/Heating Efficiency):'}
            className='text-muted-foreground mb-2'
            size={fontSizes.h14}
          />
          <RowView label='Door leak' value='Rooms 1, 2, 5, 16, 17, 18' />
          <RowView label='Pinched door seal' value='Rooms 1 and 24' />
          <RowView label='Damaged door rail' value='Room 19' />
          <RowView label='Damaged Door Seal' value='21' />
          <RowView label='Wavy door seal' value='Rooms 16, 20 and 24' />
          <RowView label='Torn door seals' value='Room 18, 20, 26 and 29' />
          <RowView label='Cracked/blown-out caulking:' value='Rooms 2, 5, 22, 25, 26, 37, 40, 44, 45 and 51' />
          <RowView label='Detached door seals' value='Room 2' />
          <RowView label='Door frame damage' value='Rooms 3, 4, 5, 6, 9, 17, 46, 47, 49 and 51' className='border-b-0' />
          <Text text='Airflow:' className='text-muted-foreground mt-3 mb-2' size={fontSizes.h14} />
          <RowView label='Gaps between sheet metal and racking' value='Room 4, 5, 6, 9, 12, 22, 27, 38, 40, 42, 44 and 48' />
          <RowView label='Gaps around sheet metal closures' value='Room 44, 45 and 51' />
          <RowView label='Improperly installed gaskets' value='Room 3, 4, 6, 9, 10, 12, 16, 22, 40 and 41' />
          <RowView label='Detached curtain' value='Room 51' />
          <RowView label='Torn curtains' value='Rooms 1, 3, 9, 12, 16, 26, 34, 42, 43 and 51' />
          <RowView label='Torn gaskets' value='Rooms 5, 6, 8, 15, 21, 22, 34, 35, 37, 44, 45 and 51' />
          <RowView label='Gasket memory' value='Rooms 1, 2, 4, 7, 8, 9, 12, 15 and 18' className='border-b-0' />
          <Text text='General Room Maintenance:' className='text-muted-foreground mt-3 mb-2' size={fontSizes.h14} />
          <RowView label='Outer door damage' value='Rooms 1, 3, 18 and 22' />
          <RowView label='Detached gasket strap' value='Room 9 and 38' />
          <RowView label='Exposed electrical outlet' value='Room 35, 38 and 41' />
          <RowView label='Misaligned RollSeal' value='Room 38' className='border-b-0' />
          <Text
            text='[Recommendations: Repair door leaks, flip gaskets if needed, correct improperly installed gasket/curtains and the gaps between sheet metal and around sheet metal]'
            className='text-muted-foreground mt-2 mb-4'
            size={fontSizes.h14}
          />
        </SectionCard>

        <div className='space-y-6 flex flex-col'>
          <SectionCard title='Air Flow and Room Loading'>
            <Text
              text='All Loaded rooms had static air pressure above the recommended minimum of 0.25 inches of water except Rooms 1, 3, 5, 7, 11 and 25. Range: 0.12 – 0.56 inches
of water. Rooms 2, 5, 18 and 29 were loaded improperly (shifted, gaps and leaning pallets).'
              className='text-muted-foreground'
              size={fontSizes.h14}
            />
            <Text
              text='[Recommendations: Remind loaders to load leaning pallets towards cell]'
              className='text-muted-foreground mt-2'
              size={fontSizes.h14}
            />
            <Text text='Temperature Control' className='font-bold mt-4' size={fontSizes.h18} />
            <Text
              text='Pulp temperatures were within ±2°F of control sensors except rooms 1, 4, 6, 7, 9, 12, and 16.'
              className='text-muted-foreground mt-2'
              size={fontSizes.h14}
            />
            <Text text='[Recommendations: Calibrate pulp probes periodically].' className='text-muted-foreground mt-2 mb-3' size={fontSizes.h14} />
          </SectionCard>
          <SectionCard title='Humidification and Ventilation'>
            <RowView label='Humidifier Function' value='All rooms were functional except room 2, 3, 12, 22, 35, 43 and 51' />
            <RowView label='Humidity Reading Range' value='78.1% – 87.8%' />
            <RowView label='Rooms Below Recommended Minimum' value='All loaded rooms' />
            <RowView label='Vent Function' value='Unobservable' className='border-b-0' />
            <Text
              text='[Recommendations: Inspect humidifiers regularly, fix non-misting humidifier]'
              className='text-muted-foreground mt-2 mb-3'
              size={fontSizes.h14}
            />
          </SectionCard>

          <SectionCard title='Sanitation Observations' className='flex-1'>
            <RowView label='Mold outer/inner doors' value='Rooms 1, 2, 4, 7, 8, 9, 10, 11, 14, 15, 16, 17, 18' />
            <RowView label='Mold on pulp probe cords' value='Room 10' />
            <RowView label='Water puddle' value='Rooms 3, 7, 8, 37, 38, 41, 42 and 44' />
            <RowView label='Mold inner/outer curtains' value='Rooms 4, 5, 6, 8, 9, 10, 12, 16, 21, 26, 27, 36, 37, 41 and 44' />
            <RowView label='Mold inner/outer gaskets' value='Rooms 9, 35, 38 and 43' />
            <RowView label='Dirt and Debris' value='Rooms 5, 6, 10, 11, 18, 21, 27 and 29' className='border-b-0' />
            <Text
              text='[Recommendations: Clean mold and debris from all room surfaces with a focus on inner door.]'
              className='text-muted-foreground mt-2 mb-3'
              size={fontSizes.h14}
            />
          </SectionCard>
        </div>
      </div>

      <div className='grid grid-cols-1 lg:grid-cols-2 gap-6 mt-6'>
        <SectionCard className='pt-2'>
          <RowView label='Staging and Selection Process' value='-' />
          <RowView label='Staging' value='-' />
          <RowView label='Start Time' value='10:00 PM' />
          <RowView label='Staging Area Location/Ambient Temperature' value='Room next to banana rooms/ 56.3 - 59.9°F' />
          <RowView label='Color Range' value='3.5 - 4.5' />
          <RowView label='Selection' value='-' />
          <RowView label='Start Time' value='3:30 PM' />
          <RowView label='Pallet Type' value='Wooden pallets are used - no slip sheets are used' />
          <RowView
            label='Pallet Type'
            value='Banana bags are used on all orders. Shrink wrap was inconsistently wrapped to the bottom of the pallet. It is mostly used to secure the
bag from flying off'
            className='flex-col gap-3'
            detailTextClassName='text-left'
          />
          <RowView
            label='Product Handling'
            value='Selectors were seen throwing and slamming the cases in a moderate to rough manner, and some selectors were seen carrying 2 cases at
a time.'
            className='flex-col gap-3'
            detailTextClassName='text-left'
          />
          <RowView
            label='Dock Ambient Temperature/Time:'
            value='Orders are held on the dock with the temp ranging from 38.1 - 41.7.'
            className='border-b-0 flex-col gap-3'
            detailTextClassName='text-left'
          />
        </SectionCard>
      </div>
    </Wrapper>
  );
};

export default FinalCompletionReport;
